import React from 'react';
import CheckNumericType from '../../functions/CheckNumeric';
// import AppImage from '../AppImage';
import Loader from '../Loader';
// import AppImage from '../AppImage';
// import Loader from '../Loader';
import styles from './styles.module.scss';
// import { AdminContext } from '../../../context/AdminContext';
// import { useContext } from 'react';

const AppFormInput = ({
  type = 'text',
  onChange,
  className = '',
  placeholder,
  value,
  title,
  error,
  showError = true,
  showProfileError = false,
  showTitle = true,
  targetType,
  maxLength,
  inputStyle = styles.inputStyle,
  prefixClass = styles.prefix,
  affixClass = styles.affix,
  prefix,
  wraperClassName = 'norhing',
  inputTitleClass,
  onFocus,
  onBlur,
  errorProfile,
  wrapperStyle = styles.wrapper,
  loading = false,
  showDescription = false,
  children,
  affix,
  disabled = false,
  prefix0,
  showExtraInfo = false,
  extraInfo,
  extraInfoStyle = styles.extraInfoStyle,
  showInput = true,

  id,
  extraButtonStyle = 'nothing',

  onKeyDown = () => console.log('keydown'),
}) => {
  // const { themeColor } = useContext(AdminContext);

  return (
    <div className={`${styles.container}${` `}${className}`}>
      <div className={`flex flex-row justify-between items-center w-full`}>
        {showTitle == true && (
          <p className={inputTitleClass ? inputTitleClass : styles.inputTitle}>
            {title}
            {showExtraInfo == true && (
              <span className={extraInfoStyle}>{extraInfo}</span>
            )}
          </p>
        )}
        {showDescription == true && <div>{children}</div>}
        {showProfileError == true && loading == true && (
          <div
            className={`flex flex-row justify-start align-center w-auto h-auto`}
          >
            <p
              className={`${styles.inputErrorProfile} preserveWhiteThemeColor`}
            >
              در حال بررسی نام
            </p>

            <Loader
              className={styles.lds_ring}
              width={'w-[20px]'}
              height={'h-[20px]'}
            />
          </div>
        )}
        {showProfileError == true && loading == false && (
          <div
            className={`flex flex-row justify-start align-center w-auto h-auto`}
          >
            <p
              className={`${styles.inputErrorProfile} preserveWhiteThemeColor`}
            >
              {errorProfile}
            </p>

            {/* <AppImage
              width={20}
              height={20}
              src="/imgs/profile/warning.svg"
              alt="warning"
              // containerclassName={` ${themeColor != 'white' && 'makeWhite'}`}
            /> */}
          </div>
        )}
      </div>
      <div
        className={`${wrapperStyle} ${extraButtonStyle} ${wraperClassName} selectButton ${
          showError == true && styles.yellowBorder
        } ${showProfileError == true && styles.redBorder}`}
      >
        {prefix0 && (
          <div
          // className={`${prefixClass}  ${
          //   themeColor != 'white' && 'makeWhite'
          // }`}
          >
            {prefix0}
          </div>
        )}
        {showInput && (
          <input
            type={type}
            inputmode={targetType == 'num' && 'numeric'}
            className={inputStyle ? inputStyle : styles.inputStyle}
            onChange={(e) => {
              // if (targetType== 'num'){
              //   console.log("hhhhh",e.target.value,CheckNumericType(e.target.value) == true ||  e.target.value.trim()?.length == 0)
              //   if(CheckNumericType(e.target.value) == true ||  e.target.value.trim()?.length == 0){
              //   onChange(e)
              //   }
              // }else{
              // onChange(e)
              // }
              if (targetType == 'num') {
                console.log(
                  'hhhhh',
                  e.target.value,
                  CheckNumericType(e.target.value) == true ||
                    e.target.value.trim()?.length == 0
                );
                if (
                  CheckNumericType(e.target.value) == true ||
                  e.target.value.trim()?.length == 0
                ) {
                  onChange(e);
                }
              } else {
                onChange(e);
              }
            }}
            placeholder={placeholder}
            value={value}
            onFocus={onFocus}
            onBlur={onBlur}
            maxLength={maxLength}
            disabled={disabled}
            onKeyDown={(e) => {
              if (e.keyCode === 8) {
              }
              onKeyDown(e);
            }}
            autoComplete="on"
            id={id}
            name={id}
          />
        )}

        {prefix && (
          <div
          // className={` ${
          //   themeColor != 'white' && 'textWhite'
          // } ${prefixClass}`}
          >
            {prefix}
          </div>
        )}
        {affix && (
          <div
            className={`${affixClass} 
           

            `}
          >
            {affix}
          </div>
        )}
      </div>
      {showError == true && error && (
        <p className={` ${styles.inputError} preserveWhiteThemeColor`}>
          {error}
        </p>
      )}
    </div>
  );
};

export default AppFormInput;
